import endOfMonth from 'date-fns/end_of_month'
import startOfMonth from 'date-fns/start_of_month'

import toISODate from './toISODate'

export const startToEndMonth = (date: Date | string) => ({
  first: toISODate(startOfMonth(date)),
  last: toISODate(endOfMonth(date)),
})
